import { render, staticRenderFns } from "./AuthSettings.vue?vue&type=template&id=4252a70b&"
import script from "./AuthSettings.vue?vue&type=script&lang=js&"
export * from "./AuthSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports